var map = {
	"./google-play-badge-da.png": "c507",
	"./google-play-badge-de.png": "b6a6",
	"./google-play-badge-en.png": "87d8",
	"./google-play-badge-es.png": "b8ac",
	"./google-play-badge-fr.png": "e0a0",
	"./google-play-badge-sv.png": "bdd7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7c7f";